module.exports = __webpack_public_path__ + "img/camera_rolate.06dfba12.svg";